import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../constants/common'
import { stopPropagation } from '../../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { QA_NAME_BUDGET_PLAN_ACTION_BUTTON } from '../RequestProfileWidgetBudgetPlan.constants'

import * as styles from './RequestProfileWidgetBudgetPlanActionButton.module.css'

import EditIcon from '../../../../../icons/edit.svg'
import PlusIcon from '../../../../../icons/plus.svg'

function RequestProfileWidgetBudgetPlanActionButton({
  className = styles.actionButton,
  isAddAction,
  qaName = QA_NAME_BUDGET_PLAN_ACTION_BUTTON,
  onClick,
  ...restProps
}) {
  const { t } = useTranslation()

  const ButtonComponent = isAddAction ? Button.Flat : Button.Outlined
  const Icon = isAddAction ? PlusIcon : EditIcon

  function handleClick(event) {
    stopPropagation(event)

    onClick?.(event)
  }

  return (
    <ButtonComponent
      {...restProps}
      isGrey
      beforeIconProps={{ Icon }}
      className={className}
      height={BUTTON_HEIGHT_32}
      qaName={qaName}
      tooltip={t(
        isAddAction
          ? 'RequestProfile.BudgetPlanWidgetAddInvoiceTooltipKey'
          : 'Common.WidgetHeaderEditButtonOpenTooltipKey'
      )}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClick}
    />
  )
}

export default RequestProfileWidgetBudgetPlanActionButton
